import styled from "styled-components"
import {mainGreen} from "../../../styles/global/colors"

export const Container = styled.div`
   width:100%;
   .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #326A32;
      border-color: #326A32;
  } 
`